/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: block;
  max-height: calc(24rem/14);
}
:host .status {
  display: inline-block;
  vertical-align: middle;
  height: calc(24rem/14);
  width: calc(24rem/14);
}
:host .status davinci-icon,
:host .status davinci-icon-ref,
:host .status davinci-spinner {
  font-size: 1rem;
}
:host .text {
  display: inline-block;
  vertical-align: middle;
  margin-top: calc(1rem/14);
  margin-right: calc(3rem/14);
  margin-left: calc(3rem/14);
  font-size: inherit;
  line-height: calc(22rem/14);
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
}

:host([value=success]) .status > davinci-icon {
  fill: #63b017;
  fill: var(--davinci-color-success, #63b017);
}

:host([value=error]) .status > davinci-icon {
  fill: #EA0823;
  fill: var(--davinci-color-error, #EA0823);
}`;
export { style };
//# sourceMappingURL=StatusLine.style.js.map